import React, { useCallback, useState } from 'react';

import { Switch, Typography } from 'antd';

import { BillingReminderTermsDialog } from './BillingReminderTermsDialog';

type SendBillingReminderSettingProps = {
  isActive: boolean;
  onChange: (isActive: boolean) => void;
  disabled?: boolean;
};

const SendBillingReminderSetting = ({ isActive, onChange, disabled }: SendBillingReminderSettingProps) => {
  const [isTermsOpen, setIsTermsOpen] = useState(false);

  const handleToggle = useCallback(
    (nextIsActive: boolean) => {
      const isDisabling = isActive && !nextIsActive;

      if (isDisabling) {
        setIsTermsOpen(true);
        return;
      }

      onChange(nextIsActive);
    },
    [isActive, onChange]
  );

  const handleClose = useCallback(() => {
    setIsTermsOpen(false);
  }, []);

  const handleConfirm = useCallback(() => {
    setIsTermsOpen(false);
    onChange(false);
  }, [onChange]);

  return (
    <>
      <div className='flex items-center gap-2'>
        <Switch checked={isActive} onChange={handleToggle} disabled={disabled} />
        <Typography.Text className='text-base'>Enviar notificações de renovação</Typography.Text>
      </div>
      <Typography.Paragraph className='text-content-subtitle mt-1 text-base'>
        Será enviado e-mail para o cliente informando a renovação de sua assinatura.
      </Typography.Paragraph>

      <BillingReminderTermsDialog open={isTermsOpen} onClose={handleClose} onConfirm={handleConfirm} />
    </>
  );
};

export default SendBillingReminderSetting;
